// routes
// components
import Iconify from 'src/components/Iconify';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const APP_ICONS = {
  exhibitors: getIcon('ic_invoice'),
  add_exhibitor: getIcon('ic_user'),
  ic_chat: getIcon('ic_chat'),
  ic_calendar: getIcon('ic_calendar'),
  ic_analytics: getIcon('ic_analytics'),
  ic_booking: getIcon('ic_booking'),
  ic_banking: getIcon('ic_banking'),
  dashboard: getIcon('ic_dashboard'),
  blog: getIcon('ic_blog'),
  cart: getIcon('ic_cart'),
  chat: getIcon('ic_chat'),
  mail: getIcon('ic_mail'),
  user: getIcon('ic_user'),
  kanban: getIcon('ic_kanban'),
  banking: getIcon('ic_banking'),
  booking: getIcon('ic_booking'),
  invoice: getIcon('ic_invoice'),
  calendar: getIcon('ic_calendar'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
};

export const IconifyIcon = (icon) => <Iconify icon={icon} width={24} height={24} />;

const navConfig = [
  {
    subheader: 'Dashboard',
    accessLevels: [1, 2, 3, 4, 5],
    package: 'all',
    items: [
      {
        title: 'Exhibitor Dashboard',
        path: '/exhibitor-dashboard/home',
        icon: APP_ICONS.dashboard,
        package: 'all',
        accessLevels: [1, 2, 3, 4, 5],
      },
    ],
  },

  {
    subheader: 'Exhibitor Details',
    accessLevels: [1, 2, 3],
    items: [
      {
        title: 'Edit Exhibitor Details',
        accessLevels: [1],
        path: '/exhibitor-dashboard/edit-details',
        icon: APP_ICONS.ic_banking,
      },
      {
        title: '3D Booth Editor',
        accessLevels: [1],
        path: '/exhibitor-dashboard/edit-booth',
        icon: IconifyIcon('bxs:cube'),
      },
      // { title: 'Music', path: '/exhibitor-dashboard/music', icon: APP_ICONS.add_exhibitor },
      //This would probably be the same as event settings since its one db.. idk, maybe not.
      // { title: 'Event controls', path: '/exhibitor-dashboard/event-controls', icon: APP_ICONS.add_exhibitor },
    ],
  },

  {
    subheader: 'Data & Analytics',
    accessLevels: [1, 2, 3],
    items: [
      {
        title: 'Exhibitor Analytics',
        path: '/exhibitor-dashboard/analytics',
        icon: APP_ICONS.ic_analytics,
        accessLevels: [1, 2, 3],
        children: [
          {
            title: 'Virtual Booth Visits',
            path: '/exhibitor-dashboard/analytics/virtual-visits',
            icon: APP_ICONS.add_exhibitor,
            accessLevels: [1, 2, 3],
          },
          {
            title: 'Physical Booth Visits',
            path: '/exhibitor-dashboard/analytics/physical-visits',
            icon: APP_ICONS.add_exhibitor,
            accessLevels: [1, 2, 3],
          },
          {
            title: 'Booth Ratings',
            path: '/exhibitor-dashboard/analytics/ratings',
            icon: APP_ICONS.add_exhibitor,
            accessLevels: [1, 2, 3],
          },
          {
            title: 'Booth Votes',
            path: '/exhibitor-dashboard/analytics/votes',
            icon: APP_ICONS.add_exhibitor,
            accessLevels: [1, 2, 3],
          },
        ],
      },
    ],
  },

  {
    subheader: 'Live Activities',
    accessLevels: [1, 2],
    items: [
      {
        title: 'Live Activities',
        path: '/exhibitor-dashboard/live-voting',
        icon: IconifyIcon('mdi:crown-circle'),
        accessLevels: [1, 2],
      },
    ],
  },

  {
    subheader: 'Video Meeting',
    accessLevels: [1, 2],
    items: [
      {
        title: 'Add Video Meeting',
        path: '/exhibitor-dashboard/zoom',
        icon: APP_ICONS.ic_booking,
        accessLevels: [1, 2],
      },
    ],
  },

  {
    subheader: 'Exhibitor Live Chat',
    accessLevels: [1, 2, 4],
    items: [
      { title: 'Live Chat', path: '/exhibitor-dashboard/live-chat', icon: APP_ICONS.ic_chat, accessLevels: [1, 2, 4] },
    ],
  },
];

export default navConfig;
